export interface PaymentServiceData {
  serviceName: String;
  serviceType: String;
  amountDds: number;
  calculatedDiscount: number | null;
  /**
   * How many of this line were sold. Only an additional service or a good is ever more than one,
   * and the call centre screen shares this model without showing the column at all, so a caller
   * that says nothing means one.
   */
  quantity: number;
}

export function createPaymentServiceData(serviceName: String, serviceType: String, amountDds: number, calculatedDiscount: number | null, quantity: number = 1): PaymentServiceData {
  return {
    serviceName: serviceName,
    serviceType: serviceType,
    amountDds: amountDds,
    calculatedDiscount: calculatedDiscount,
    quantity: quantity,
  };
}